import { useFormikContext } from 'formik';
import { isNil } from 'lodash/fp';
import { useEffect } from 'react';
import { AmountUnit } from '../../../../api/types';
import { useFinanceProductDetailContext } from '../FinanceProductDetailContext';
import { type FinanceProductFormValues } from '../FinanceProductForm';
import { type SettingsKey } from './typings';

const useAlignUnits = (
    settingsKey: SettingsKey,
    use: boolean,
    minUnit: AmountUnit,
    maxUnit: AmountUnit,
    stepUnit: AmountUnit,
    stepKey: string,
    stepUnitKey: string
) => {
    const { bank } = useFinanceProductDetailContext();
    const amountRoundingDecimals = bank?.module?.company?.roundings?.amount?.decimals;
    const { setFieldValue } = useFormikContext<FinanceProductFormValues>();

    useEffect(() => {
        if (use && !isNil(minUnit) && !isNil(maxUnit) && !isNil(stepUnit)) {
            if (
                minUnit === AmountUnit.Currency &&
                maxUnit === AmountUnit.Currency &&
                stepUnit !== AmountUnit.Currency
            ) {
                setFieldValue(`${settingsKey}.${stepUnitKey}`, AmountUnit.Currency);
            }

            if (minUnit !== maxUnit) {
                if (stepUnit !== AmountUnit.Currency) {
                    setFieldValue(`${settingsKey}.${stepUnitKey}`, AmountUnit.Currency);
                }

                const step = Number.isFinite(amountRoundingDecimals) ? 10 ** -amountRoundingDecimals : null;
                if (Number.isFinite(step)) {
                    setFieldValue(`${settingsKey}.${stepKey}`, step);
                }
            }
        }
    }, [amountRoundingDecimals, maxUnit, minUnit, setFieldValue, settingsKey, stepKey, stepUnit, stepUnitKey, use]);
};

export default useAlignUnits;
